<template>
  <!-- 车主模块认证 -->
  <div class="car-main">
    <header class="header">
      <img src="../../assets/images/attestation/car-main-back.png" alt="" srcset="">
    </header>
    <div class="message-box">
      <div class="input-item vclNo flex" @click.stop="openKeyBoard">
        <div class="label">车牌号</div>
        <div class="vclNo-box flex8" :class="!userData.vno ? 'unentry' : ''">{{ userData.vno || '请输入车牌号' }}</div>
      </div>
      <div class="input-item flex name-box">
        <div class="label">车主姓名</div>
        <input class="flex8" v-model="userData.name" placeholder="请输入姓名" type="text" />
      </div>
      <div class="input-item flex phone">
        <div class="label">手机号</div>
        <input class="flex8" v-model="userData.phone" placeholder="请输入车主登记手机号" type="number" />
      </div>
      <div class="input-item flex is-driver">
        <div class="label">我也是驾驶员？</div>
        <van-radio-group class="flex radio-group-box" v-model="is_driver">
          <van-radio checked-color="#5572FC" :name="0">是</van-radio>
          <van-radio checked-color="#5572FC" style="margin-left:20px" :name="1">否</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="contact-service" v-if="!isAndroidApp">
      如有疑问请<span  @click.stop="goContact">联系客服</span>
    </div>
    <van-button class="btn" @click="submitBtn" :loading="btnLoading" type="info" loading-text="审核中..." >提交审核</van-button>
    <truck-keyboard
      v-if="showKeyBoard"
      :searchTitle="'关闭'"
      :vclNo="userData.vno"
      @searchBtn="showKeyBoard=false"
      @deletevclNo="keyBoardDeletevclNo"
      @confirm="getkeyBoard">
    </truck-keyboard>
    <first-examine-result
      ref="FirstExamineResult"
      :code="examineCode"
      @cancel="examineCancelBtn"
      @define="examineDefineBtn"
      @tipdefine="examineTipDefineBtn"
    >
    </first-examine-result>
    <success-dialog
      :code="examineCode"
      :type="0"
      @define="successDigDefinBtn"
      ref="SuccessDialog"
    >
    </success-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant'
import FirstExamineResult from '../../components/dialog/Attestation/firstExamineResult'
import SuccessDialog from '../../components/dialog/Attestation/successDialog'
import { wxRedirectTo, wxRaLunch, wxNavigateTo } from '../../utils/WeChatUtil'
import TruckKeyboard from '../../components/truckKeyboard/index'
import { getAuthInfoDraft, createZyOwnerAuth } from '../../api/attestation'
const phoneTel = /^1(3|4|5|6|7|8|9)\d{9}$/
export default {
  props: {},
  data() {
    return {
      userData: {
        name: '',
        phone: '',
        vno: ''
      }, // 用户信息
      vclNo: null, // 车牌号
      is_driver: 0, // 是否是司机 0 是 1 不是
      showKeyBoard: false, // 显示键盘
      examineCode: null,
      btnLoading: false, // 审核btnloading
    };
  },
  computed: {},
  components: {
    TruckKeyboard,
    FirstExamineResult,
    SuccessDialog
  },
  async created() {
    document.body.addEventListener('click', this.closeKeyBoard, false)
    await this.getdraftData()
  },
  mounted() {
  },
  watch: {},
  methods: {
    /**
     *
     * @param data 键盘输入的车牌
     *
     * 获取键盘输入的数据
    */
    getkeyBoard(data) {
      const { vno } = this.userData
      this.userData.vno = vno + data
    },
    /**
     *
     *
     * 关闭键盘
    */
    closeKeyBoard () {
      this.showKeyBoard = false
    },
    /**
     *
     *
     * 删除车牌号一位
    */
    keyBoardDeletevclNo() {
      const { vno } = this.userData
      this.userData.vno = vno.substring(0, vno.length-1)
    },
    /**
     *
     *
     * 显示键盘输入车牌号
    */
    openKeyBoard() {
      this.showKeyBoard = !this.showKeyBoard
    },
    /**
     *
     *
     * 去联系客服页面
    */
    goContact() {
      if (this.isWechart) {
        wxNavigateTo('/pages/custom/custom')
      }
    },
    /**
     *
     *
     * 获取认证时的草稿信息
    */
    async getdraftData() {
      const response =  await getAuthInfoDraft()
      if (response.success) {
        console.log(response.data)
        const { phone, name } = response.data
        this.userData.phone = phone
        this.userData.name = name
      }
    },
    /**
     *
     *
     * 提交审核
    */
    async submitBtn() {
      const { name, phone, vno } = this.userData
      if (!navigator.onLine) {
        Toast('网络异常，请检查网络')
        this.btnLoading = false
        return
        // 断网了
      }
      if (!vno) {
        Toast('请输入车牌号')
        return
      }
      if (vno.length < 7) {
        Toast('请输入正确的车牌号')
        return
      }
      if (!name) {
        Toast('请输入姓名')
        return
      }
      if (!phone) {
        Toast('请输入手机号码')
        return
      }
      if (!phoneTel.test(phone)) {
        Toast('请输入正确的手机号码')
        return
      }
      const param = {
        ...this.userData,
        hasDriver: this.is_driver === 0
      }
      this.btnLoading = true
      const response = await createZyOwnerAuth(param)
      this.btnLoading = false
      if (response) {
        const { success, code } = response
        if (success) {
          this.examineCode = 0
          if (this.isWechart) {
            this.$refs.SuccessDialog.showPopup()
          }
        } else {
          this.examineCode = code
          if (this.isWechart) {
            if (code === 70420) {
              this.gonext()
            } else if (code === 70421){
              wxRaLunch('/pages/index/index')
            } else {
              this.$refs.FirstExamineResult.showPopup()
            }
          }
        }
        console.log(response)
        console.log(response.data)
      }
    },
    /**
     *
     *
     * 认证失败取消弹框点击事件
    */
    examineCancelBtn() {
      if (this.isWechart) {
        if (this.examineCode !== 70417) {
          this.gonext()
        }
      }
    },
    /**
     *
     *
     * 认证失败确定弹框点击事件
    */
    examineDefineBtn() {
      if (this.isWechart) {
        if (this.examineCode === 70417) {
          this.gonext()
        }
      }
    },
    /**
     *
     *
     * 认证失败tip确定点击事件
    */
    examineTipDefineBtn() {
      if (this.isWechart) {
        if (this.examineCode === 70402) {
          wxRedirectTo('/pages/index/index')
        } else if (this.examineCode === 70417) {
          this.gonext()
        }
      }
    },
    /**
     *
     *
     * 去认证页面第二步
    */
    gonext() {
      const { vno, name, phone } = this.userData
      let href = window.location.href
      href = href.replace(/car-main/, 'vehicle-owner')
      href += `&vno=${vno}&name=${name}&phone=${phone}&hasDriver=${this.is_driver}`
      window.location.href = href
    },
    /**
     *
     *
     *
     * 成功弹框确定事件
    */
    successDigDefinBtn() {
      wxRaLunch('/pages/index/index')
    },
  }
};
</script>

<style scoped lang="scss">
.car-main {
  .header {
    width: 100%;
    img {
      width: 100%
    }
  }
  .flex8 {
    flex: .8
  }
  .message-box {
    background-color: #ffffff;
    align-items: center;
    .input-item {
      padding: 30px 0px;
      margin: 0 20px;
      font-size: 28px;
      border-bottom: 1px solid #E5E5E5;
      .label {
        color: #989898;
        flex: .3
      }
      .radio-group-box {
        flex: .7
      }
      input::-webkit-input-placeholder {
        color: #E5E5E5;
        -webkit-text-fill-color: #E5E5E5;
        -webkit-opacity: 1;
        opacity: 1;
      }
    }
  }
  .unentry {
    color: #E5E5E5;
  }
  .contact-service {
    font-size: 24px;
    color: #CCCCCC;
    text-align: center;
    padding-top: 60px;
    span {
      color: #5572FD;
      text-decoration:underline;
    }
  }
  .btn {
    background-color: #5572FD;
    color: #ffffff;
    border-radius: 3px;
    font-size: 28px;
    text-align: center;
    line-height: 80px;
    height: 80px;
    width: 90%;
    margin: 30px 0;
    left: 50%;
    margin-left: -45%;
  }
}
</style>
